import { css, keyframes, Theme } from "@emotion/react";
import styled from "@emotion/styled";

export const container = (width: undefined | string | number) =>
    css({
        position: "relative",
        display: "inline-block",
        width: width,
    });

export const PopupContainer = styled.div(props => ({
    backgroundColor: props.theme.candy.keyPalette.primaryBackgroundColor,
    minWidth: 250,
}));

export const textLengthInfo = (opened: boolean) => (theme: Theme) =>
    css({
        color: theme.candy.typography.inactive.color,
        position: "absolute",
        right: 8,
        bottom: 6,
        zIndex: 2,
        backgroundColor: opened ? "transparent" : theme.candy.keyPalette.primaryBackgroundColor,
        padding: "0 4px",
    });

export const currentLength = (error: boolean) => (theme: Theme) =>
    css(
        error && {
            color: theme.candy.semanticColors.danger.color,
            fontWeight: 600,
        }
    );

const blinkAnimation = (theme: Theme) =>
    keyframes({
        "0%": {
            backgroundColor: theme.candy.valueControls.blinkColor,
        },
    });

export const WithAuto = styled.span<{ width?: number | string }>(props => ({
    display: "inline-flex",
    width: props.width,
    justifyContent: "start",
}));

export const blink = (theme: Theme) =>
    css({
        textarea: {
            animation: `${blinkAnimation(theme)} 0.15s ease-in`,
        },
    });
